<script setup lang="ts">
import { getI18n } from '@/helpers/i18n';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        backText?: string;
        nextText?: string;
        disabled?: boolean;
        prevDisabled?: boolean;
        nextDisabled?: boolean;
        loading?: boolean;
    }>(),
    {
        backText: () => getI18n().t('back'),
        nextText: () => getI18n().t('to_next_step'),
        disabled: false,
        prevDisabled: false,
        nextDisabled: false,
        loading: false
    }
);

defineEmits(['back', 'next']);

const isPrevDisabled = computed(() => props.disabled || props.prevDisabled || props.loading);
const isNextDisabled = computed(() => props.disabled || props.nextDisabled);
</script>

<template>
    <div class="btn-container mt-1rem">
        <ktg-button class="flex-1" appearance="secondary" :disabled="isPrevDisabled" @click="$emit('back')">{{
            props.backText
        }}</ktg-button>
        <ktg-button
            class="flex-1"
            appearance="primary"
            :disabled="isNextDisabled"
            @click="$emit('next')"
            :loading="props.loading"
            >{{ props.nextText }}</ktg-button
        >
    </div>
</template>

<style scoped>
.btn-container {
    display: flex;
    gap: 1rem;
    flex-direction: row;
    ktg-button {
        flex: 1 1 0%;
    }
}
</style>
